import router from "@/router";

export let iosAppEvent = window.webkit
export let appEvent = ''

if (iosAppEvent) {
    appEvent = window.webkit.messageHandlers.jsMethodList
}

function getUserInfo(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'getUserInfo',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        let data = {
            userId: "1935890887274536961",
            nickName: "光明码圣",
            token: "9a5f10c7900041da84cbea61d6dc6fef",
            invitationCode: "ZT05397374",
            phoneNum: "",
            taskPhoneNum: "",
            headImage:
                "https://thirdwx.qlogo.cn/mmopen/vi_32/QYHKCovO9MCFvlcFb7z4jmibLCHeyFtdIxbgYmcKc3GxMKgmtXRupImojiaMz5HOTxBicia4snYibQL4tyCVxV5ibM0g/132",
        }
        localStorage.setItem('userInfo', JSON.stringify(data))
    }
}

function imgDownload(res, callBackName) {
    console.log(res)
    if (appEvent) {
        let data = {
            method: 'imgDownload',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function b64ImgDownload(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'b64ImgDownload',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function copyContent(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'copyContent',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function openApp(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'openApp',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function openNewBrowser(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'openNewBrowser',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log(res)
        router.push({
            path: res,
        })
        console.log('不是app内')
    }
}

function offBrowser(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'offBrowser',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function backHistory(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'backHistory',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function updateUserInfo(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'updateUserInfo',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function placardShare(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'placardShare',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function getLoaction(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'getLoaction',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        // window.setLoaction(JSON.stringify({
        //     lat: 34.767444,
        //     lon: 113.732478,
        //     city: '郑州市',
        // }))
        console.log('不是app内')
    }
}

function openWxMini(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'openWxMini',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        let data = {
            method: 'openWxMini',
            data: res,
            callback: callBackName,
        }
        console.log(JSON.stringify(data))
        console.log('不是app内')
    }
}

function openWxAccredit(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'openWxAccredit',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function toAppIndexPage(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'toAppIndexPage',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function shareWxPy(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'shareWxPy',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function shareWxPyq(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'shareWxPyq',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function imgShareWxPy(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'imgShareWxPy',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function imgShareWxPyq(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'imgShareWxPyq',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function openAppPage(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'openAppPage',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function commonShareWXMini(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'commonShareWXMini',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function openVideo(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'openVideo',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function loadRewardAd(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'loadRewardAd',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function pandaRewardAd(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'pandaRewardAd',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function kongtouRewardAd(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'kongtouRewardAd',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function goldReward(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'goldReward',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function onEventSubmit(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'onEventSubmit',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function showLoading(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'showLoading',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function hideLoading(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'hideLoading',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function skipSettingLocation(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'skipSettingLocation',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function skipRedEvenlopeVC(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'skipRedEvenlopeVC',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function friendBoost(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'friendBoost',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

function bindPhoneNumView(res, callBackName) {
    if (appEvent) {
        let data = {
            method: 'bindPhoneNumView',
            data: res,
            callback: callBackName,
        }
        appEvent.postMessage(JSON.stringify(data))
    } else {
        console.log('不是app内')
    }
}

export let iosFun = {
    getUserInfo,
    imgDownload,
    b64ImgDownload,
    copyContent,
    openApp,
    openNewBrowser,
    offBrowser,
    backHistory,
    updateUserInfo,
    placardShare,
    getLoaction,
    openWxMini,
    openWxAccredit,
    toAppIndexPage,
    shareWxPy,
    shareWxPyq,
    imgShareWxPy,
    imgShareWxPyq,
    openAppPage,
    commonShareWXMini,
    openVideo,
    loadRewardAd,
    pandaRewardAd,
    kongtouRewardAd,
    goldReward,
    onEventSubmit,
    showLoading,
    hideLoading,
    skipSettingLocation,
    skipRedEvenlopeVC,
    friendBoost,
    bindPhoneNumView,
}
